import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip } from "antd";
import InputForm from "./InputForm";
import { validateEmail, CPFValido, CNPJValido } from '../utils/Validator';
import { maskTelefone, maskCNPJ, maskCPF, maskDate, limparCpfCnpj, somenteNumeros } from '../utils/Masker';
import axios from 'axios';
import "./Form.css";
import MunicipioFrame from './MunicipioFrame';
import moment from "moment-timezone";

const { Item: ItemForm } = Form;

export default class ClienteForm extends Component {
  state = {
    registro: {
      pes_codigo: '',
      pes_nome: '',
      pes_razao_social: '',
      pes_cpf_cnpj: '',
      pes_inscr_est: '',
      pes_email: '',
      pes_situacao: '',
      pes_cep: '',
      pes_endereco: '',
      pes_complemento: '',
      pes_bairro: '',
      pes_numero: '',
      pes_municipio: { key: '0' },
      pes_obs: '',

      pes_limite_credito: false,
      pes_data_limite_credito: '',
      pes_valor_limite_credito: 0,
    },

    condPagtosSelect: [],
    OPCOES_COMBO: [],
  };

  componentDidMount() {
    this.buscaCondPagtos();
  }

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
        condPagtosSelect: this.props.registroSelecionado.condPagtosSelect ? this.props.registroSelecionado.condPagtosSelect : [],
      }, () => {
        this.refs.pes_cpf_cnpj.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeMunicipio = event => {
    const { registro } = this.state;
    registro['pes_municipio'] = event.pes_municipio;
    this.setState(event);
  }

  normalizeCpfCnpj = () => {
    const { registro } = this.state;
    const cpfcnpj = limparCpfCnpj(registro.pes_cpf_cnpj);

    if (cpfcnpj) {
      if (/^[0-9]{11}$/.test(cpfcnpj)) {
        registro.pes_cpf_cnpj = maskCPF(cpfcnpj);
        this.setState({ registro });
      } else {
        registro.pes_cpf_cnpj = maskCNPJ(cpfcnpj);
        this.setState({ registro });
      }
    }
  };



  onOK = () => {
    const { registro } = this.state;

    const PFJ = limparCpfCnpj(registro.pes_cpf_cnpj);
    if (PFJ) {
      if (/^[0-9]{11}$/.test(PFJ)) {
        if (!CPFValido(PFJ)) {
          Modal.warning({
            title: 'Aviso!',
            content: 'CPF Inválido',
          });
          return;
        }
      } else {
        if (!CNPJValido(PFJ)) {
          Modal.warning({
            title: 'Aviso!',
            content: 'CNPJ Inválido',
          });
          return;
        }
      }
    }

    if ((this.state.registro.pes_limite_credito) && ((!this.state.registro.pes_data_limite_credito) || (!moment(this.state.registro.pes_data_limite_credito, 'DD/MM/YYYY', true).isValid()))) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida para o Limite de Crédito' });
      return;
    }


    const reg = {
      ...registro,

      pes_cpf_cnpj: limparCpfCnpj(this.state.registro.pes_cpf_cnpj),
      pes_cep: this.state.registro.pes_cep ? String(this.state.registro.pes_cep).replace(/[^0-9]/g, '') : '',
      pes_municipio: registro.pes_municipio.key,

      condPagtosSelect: this.state.condPagtosSelect,

      pes_data_limite_credito: this.state.registro.pes_limite_credito ? moment(this.state.registro.pes_data_limite_credito, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
      pes_valor_limite_credito: this.state.registro.pes_limite_credito ? this.state.registro.pes_valor_limite_credito : 0,
    };

    // console.log('onOK: ', reg)
    // return;

    this.props.onSalvarClick(reg);
  };



  buscaCondPagtos = () => {
    this.setState({ OPCOES_COMBO: [] });
    // console.log('buscaCondPagtos: ')

    axios.get('/condPagto/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO = data.map(regList => {
          return {
            key: String(regList.cp_idf),
            label: regList.cp_descricao,
          }
        });
        this.setState({ OPCOES_COMBO });
      }).catch(error => {
        console.error(error.response);
      })
  }

  onBuscarCNPJClick = (cnpj) => {
    const busca = somenteNumeros(cnpj);
    const cnpjLimpo = limparCpfCnpj(cnpj);
    const { registro } = this.state;

    if (/[A-Z]/.test(cnpjLimpo)) {
      Modal.warning({
        title: 'Aviso!',
        content: 'A consulta automática de CNPJ ainda aceita somente CNPJ numérico.',
      });
      return;
    }

    if ((busca) && (busca.length === 14)) {
      if (!CNPJValido(busca)) {
        Modal.warning({ title: 'Aviso!', content: 'Só é permitido a consulta de CNPJ Válido' });
        return;
      }

      this.setState({ carregandoCNPJ: true })
      axios.get('/pessoas/buscaCNPJ/' + busca)
        .then(response => {
          const { data } = response;
          // console.log('first', data)
          if (data.sucesso) {
            this.setState({
              registro: {
                ...registro,
                pes_nome: data.razao_social,
                pes_razao_social: data.razao_social,
                pes_endereco: data.logradouro,
                pes_complemento: data.complemento,
                pes_bairro: data.bairro,
                pes_numero: data.numero,
                pes_cep: data.cep,
                pes_fone1: data.telefones && data.telefones[0] ? '(' + data.telefones[0].ddd + ')' + data.telefones[0].numero : '',
                pes_municipio: {
                  key: String(data.cmunicipio),
                  label: data.municipio,
                  cmun_uf: String(data.cuf),
                  cuf_sigla: data.uf,
                },
              },
              carregandoCNPJ: false
            });
          } else {
            Modal.warning({ title: 'Aviso!', content: 'Dados do CNPJ não encontrado' });
            this.setState({
              registro: {
                ...registro,
                pes_nome: '',
                pes_razao_social: '',
                pes_endereco: '',
                pes_complemento: '',
                pes_bairro: '',
                pes_numero: '',
                pes_cep: 0,
                pes_fone1: '',
                pes_municipio: {
                  key: '0',
                  label: '',
                  cmun_uf: '',
                  cuf_sigla: '',
                },
              },
              carregandoCNPJ: false
            });
          }
        }).catch(error => {
          this.setState({ carregandoCNPJ: false });
          console.error(error.response);
          Modal.warning({ title: 'Aviso!', content: 'Dados do CNPJ não encontrado.' });
        })
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Só é permitido a consulta de CNPJ Válido' });
      this.setState({
        registro: {
          ...registro,
          pes_nome: '',
          pes_razao_social: '',
          pes_endereco: '',
          pes_complemento: '',
          pes_bairro: '',
          pes_numero: '',
          pes_cep: 0,
          pes_fone1: '',
          pes_municipio: {
            key: '0',
            label: '',
            cmun_uf: '',
            cuf_sigla: '',
          },
        },
        carregandoCNPJ: false
      });
    }

  }







  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { OPCOES_COMBO, condPagtosSelect, carregandoCEP } = this.state;
    const { pes_codigo, pes_nome, pes_razao_social, pes_email, pes_cpf_cnpj, pes_inscr_est, pes_cep, pes_endereco, pes_complemento,
      pes_obs, pes_bairro, pes_numero, pes_municipio, pes_fone1, pes_fone2, pes_fone3, pes_vendedor, pes_vendedor1, pes_vendedor2, pes_limite_credito, pes_data_limite_credito, pes_valor_limite_credito,
    } = this.state.registro;

    // console.log('render: ', this.state)

    return (
      <Modal
        title={pes_codigo ? "Edição de Cliente" : "Cadastro de Cliente"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
              <span>Código</span>
              <InputForm
                id="pes_codigo"
                value={pes_codigo}
                readOnly
              />
            </Col>

            <Col xs={24} sm={6} style={{}}>
              <span>CPF/CNPJ</span>
              <InputForm
                id="pes_cpf_cnpj"
                ref="pes_cpf_cnpj"
                maxLength={60}
                onChange={this.onChange}
                value={pes_cpf_cnpj}
                validator={value => Boolean(value)}
                onBlur={this.normalizeCpfCnpj}
              // masker={String(pes_cpf_cnpj).length <= 13 ? maskCPF : maskCNPJ}
              />
            </Col>

            <Col xs={24} sm={1} style={{ paddingRight: 20, marginTop: 25 }}>
              <Tooltip title="Buscar Dados do CNPJ" placement="topLeft">
                <Button
                  type="dashed"
                  icon="search"
                  htmlType="button"
                  loading={carregandoCEP}
                  onClick={() => this.onBuscarCNPJClick(pes_cpf_cnpj)}
                />
              </Tooltip>
            </Col>

            <Col xs={24} sm={13} style={{}}>
              <span>Nome</span>
              <InputForm
                id="pes_nome"
                ref="pes_nome"
                maxLength={60}
                onChange={this.onChange}
                value={pes_nome}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Razão Social</span>
              <InputForm
                id="pes_razao_social"
                ref="pes_razao_social"
                maxLength={60}
                onChange={this.onChange}
                value={pes_razao_social}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Endereço</span>
              <InputForm
                id="pes_endereco"
                ref="pes_endereco"
                maxLength={200}
                onChange={this.onChange}
                value={pes_endereco}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={5} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Complemento</span>
              <InputForm
                id="pes_complemento"
                ref="pes_complemento"
                maxLength={100}
                onChange={this.onChange}
                value={pes_complemento}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={3} style={{ marginTop: -20 }}>
              <span>Nº</span>
              <InputForm
                id="pes_numero"
                ref="pes_numero"
                maxLength={5}
                onChange={this.onChange}
                value={pes_numero}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Bairro</span>
              <InputForm
                id="pes_bairro"
                ref="pes_bairro"
                maxLength={60}
                onChange={this.onChange}
                value={pes_bairro}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>CEP</span>
              <InputForm
                id="pes_cep"
                ref="pes_cep"
                value={pes_cep}
                maxLength={10}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <MunicipioFrame
                label="Município"
                id="pes_municipio"
                value={pes_municipio}
                width={"100%"}
                onChange={this.onChangeMunicipio}
                descricaoPrimeiroItem="Todos os Municípios"
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Telefone</span>
              <InputForm
                id="pes_fone1"
                ref="pes_fone1"
                value={pes_fone1}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Telefone</span>
              <InputForm
                id="pes_fone2"
                ref="pes_fone2"
                value={pes_fone2}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Telefone</span>
              <InputForm
                id="pes_fone3"
                ref="pes_fone3"
                value={pes_fone3}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }}>
              <span>Inscrição Estadual</span>
              <InputForm
                id="pes_inscr_est"
                ref="pes_inscr_est"
                value={pes_inscr_est}
                maxLength={14}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Vendedor</span>
              <InputForm
                id="pes_vendedor"
                ref="pes_vendedor"
                value={pes_vendedor}
                maxLength={10}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Vendedor</span>
              <InputForm
                id="pes_vendedor1"
                ref="pes_vendedor1"
                value={pes_vendedor1}
                maxLength={10}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Vendedor</span>
              <InputForm
                id="pes_vendedor2"
                ref="pes_vendedor2"
                value={pes_vendedor2}
                maxLength={10}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={24} style={{ marginTop: -20 }}>
              <span>Email</span>
              <InputForm
                type="email"
                id="pes_email"
                ref="pes_email"
                value={pes_email}
                validator={validateEmail}
                onChange={this.onChange}
              />
            </Col>



            <Col xs={24} sm={4} style={{ marginTop: 0 }} >
              <InputForm
                type="checkbox"
                id="pes_limite_credito"
                ref="pes_limite_credito"
                onChange={this.onChange}
                value={pes_limite_credito}
              >
                Limite de Crédito
              </InputForm>
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Valor Limite Crédito</span>
              <InputForm
                type="number"
                id="pes_valor_limite_credito"
                ref="pes_valor_limite_credito"
                value={pes_valor_limite_credito}
                onChange={this.onChange}
                disabled={pes_limite_credito ? false : true}
              />
            </Col>

            <Col xs={24} sm={6} style={{ marginTop: -20 }}>
              <span>Data Limite Crédito</span>
              <InputForm
                type="date"
                id="pes_data_limite_credito"
                ref="pes_data_limite_credito"
                value={pes_data_limite_credito}
                masker={maskDate}
                validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                dateFormat="DD/MM/YYYY"
                onChange={this.onChange}
                errorMessage="Formato correto DD/MM/AAAA"
                className="input-data-avaliacao"
                style={{ width: "100%" }}
                disabled={pes_limite_credito ? false : true}
              />
            </Col>


            <Col xs={24} sm={24} style={{ marginTop: -10 }}>
              <span>Condições de Pagamentos Vinculadas</span>
              <InputForm
                type="select"
                id="condPagtosSelect"
                ref="condPagtosSelect"
                value={condPagtosSelect}
                placeholder="Selecione as Condições de Pagamentos"
                onChange={this.onChange}
                data={OPCOES_COMBO}
                multiple
              />
            </Col>

            <Col xs={24} sm={24} style={{ marginTop: -20 }}>
              <span>Observação</span>
              <InputForm
                id="pes_obs"
                ref="pes_obs"
                value={pes_obs}
                maxLength={100}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ClienteForm.js